import { yupResolver } from "@hookform/resolvers/yup";
import Div from "@jumbo/shared/Div/Div";
import {
  FormControlLabel,
  Grid,
  Radio,
  TextField,
  Typography,
} from "@mui/material";
import { BASE_URL, Tenantname } from "app/services/auth-services";
import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import { Card } from "react-bootstrap";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { toast } from "react-toastify";
import ViewApprovalLeaves from "../hr/LeaveManagement/ApplyLeave/ViewApprovalLeaves";
import ViewTimesheets from "../hr/TimeManagement/ViewTimesheets";
import { formatIndianNumber } from "app/shared/ReuseComponents/DateFormatter";
import OverviewFullandFinalSettlement from "../hr/FullandFinalSettlement/OverviewFullandFinalSettlement";
import {
  ErpDateField,
  ErpSaveUpdateButton,
} from "app/shared/ReuseComponents/ButtonComponent";
import ViewResignation from "../hr/resignation/ViewResignation";
import {
  CustomButton,
  FirstLetterCaps,
  returnMailToInitiator as importedReturnMailToInitiator,
} from "app/shared/ReuseComponents/StyledComponents";
import AttendanceDocumentApproval from "../hr/AttendanceManagement/AttendanceDocumentApproval";
import PayslipDocumentApproval from "../hr/PayrollManagement/PayslipDocumentApproval";
import ViewEmployeeClaims from "../hr/EmployeeClaims/ViewEmployeeClaims";
import { generateHRApprovalMail } from "app/utils/documentUtils";
import LeaveCancellationDocumentApproval from "../hr/LeaveManagement/LeaveCancellation/LeaveCancellationDocumentApproval";


function DocumentUserApproval({
  setOpen,
  setMainPage,
  documentId,
  dateFormat,
  fetchData,
}) {
  const token = localStorage.getItem("accesstoken");

  const header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  const [requests, setRequests] = useState({});
  const [moduleName, setModuleName] = useState("");
  const [openViewRequest, setOpenViewRequest] = useState(false);
  const [closeRequest, setCloseRequest] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [releivingDate, setReleivingDate] = useState("");
  const [approvals, setApprovals] = useState([
    {
      id: "",
      Approvername: "",
      ApproverRole: "",
      comments: "",
      status_btn: "",
      Approved_flg: false,
      status: true,
      time: "",
    },
  ]);

  const [reqId, setReqId] = useState([]);
  const [initiated, setInitiated] = useState({});
  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const employeeId = parseInt(localStorage.getItem("EmployeeId"));
  const userId = parseInt(localStorage.getItem("UserId"));
  const HeadApproverName = localStorage.getItem("ReportHeadName");
  const HeadApproverRole = localStorage.getItem("ReportHeadRole");

  const workflowMapping = {
    "Erpapp.leave": "Leave",
    "Erpapp.leavecancellation": "Leave Cancellation",
    "Erpapp.timesheet": "timesheet",
    "Erpapp.reimbursement": "Reimbursement",
    "Erpapp.attandancemaster": "Attandance Management",
    "Erpapp.fullandfinal": "Full and Final Settlement",
    "Erpapp.payslipheader": "payroll management",
    "Erpapp.supplierinvoicedetail": "Supplier Invoice Detail",
    "Erpapp.employeeresignation": "Resignation",
  };

  // Default to "Supplier Invoice Detail" if the moduleName is not in the mapping
  const WorkflowName = workflowMapping[moduleName] || "Purchase Request";

  const [employeeLists, setEmployeeLists] = useState([]);
  console.log("WorkflowName", WorkflowName);
  useEffect(async () => {
    if (
      WorkflowName === "Attandance Management" ||
      WorkflowName === "Payroll Management"
    ) {
      await axios
        .get(
          `${BASE_URL}/Felix/HREmployeelist/?Partner_Id=${requests[0]?.Partner_Id}`,
        )
        .then((res) => {
          setEmployeeLists(res?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [requests[0]?.Partner_Id]);

  useEffect(() => {
    setApprovals(documentId?.Approve);
    setReqId(documentId?.Request_Id);
    setInitiated(documentId?.Created_By);
  }, [documentId]);

  // get a request component datas
  useEffect(() => {
    const getRequestData = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/Felix/directapproval/?Document_Id=${documentId?.Request_Id}`,
          header,
        );
        const resData = response.data;
        console.log("resDataresData", resData);
        if (resData.length > 0) {
          const list = { ...resData[0]?.fields, id: resData[0]?.pk };
          // console.log("LLLKKK...", resData, list);
          setRequests(list);
          setModuleName(resData[0]?.model);
        } else {
          console.log("No data found");
        }
      } catch (error) {
        console.error("Error fetching request data", error);
      }
    };

    if (documentId?.Request_Id) {
      getRequestData();
    }
  }, [documentId]);

  useEffect(() => {
    const fetchFullRequestDetails = async () => {
      if (!moduleName || !requests?.id) return;

      let endpoint = "";
      const reqId = requests.id;

      switch (moduleName) {
        case "Erpapp.leave":
          endpoint = `/Felix/Getleave/?id=${reqId}`;
          break;
        case "Erpapp.leavecancellation":
          endpoint = `/Felix/LeavecancellationwithouttokenCRUD/?id=${reqId}`;
          break;
        case "Erpapp.timesheet":
          endpoint = `/Felix/TimeSheetwithoutCRUD/?id=${reqId}`;
          break;
        case "Erpapp.reimbursement":
          endpoint = `/Felix/EmployeeClaimGetById/?id=${reqId}`;
          break;
        case "Erpapp.fullandfinal":
          endpoint = `/Felix/FullandFinalCRUD/?id=${reqId}`;
          break;
        case "Erpapp.employeeresignation":
          endpoint = `/Felix/EmployeeResignationGet/?id=${reqId}`;
          break;
        case "Erpapp.attandancemaster":
          endpoint = `/Felix/Attandancemasterget/?id=${reqId}`;
          break;
        case "Erpapp.payslipheader":
          endpoint = `/Felix/PayslipwithoutCRUD/?id=${reqId}`;
          break;
        default:
          return;
      }

      try {
        const res = await axios.get(`${BASE_URL}${endpoint}`, header);
        if (res?.data) {
          const data = res.data?.results ?? res.data;
          const fullObj = Array.isArray(data) ? data[0] : data;
          if (fullObj) {
            setRequests((prev) => ({ ...prev, ...fullObj }));
          }
        }
      } catch (err) {
        console.error("Error fetching full request details:", err);
      }
    };

    fetchFullRequestDetails();
  }, [moduleName, requests?.id]);


  const handleBack = () => {
    setOpen(false);
    setMainPage(true);
  };

  // const handleChangeApproverRequest = (e, index, id) => {
  //   const { name, value } = e.target;
  //   const list = [...approvals];
  //   if (id === employeeId) {
  //     list[index][name] = value;
  //     if (list[index].status_btn === "yes") {
  //       list[index].status = true;
  //       list[index].Approved_flg = true;
  //       list[index].time = new Date().toJSON();
  //     } else if (list[index].status_btn === "no") {
  //       list[index].status = false;
  //       list[index].Approved_flg = false;
  //       list[index].time = new Date().toJSON();
  //     }
  //     setApprovals(list);
  //   }
  // };

  const handleChangeApproverRequest = (e, index, id) => {
    const { name, value } = e.target;

    // Only allow changes if this is the current employee
    if (parseInt(id) !== parseInt(employeeId)) return;

    // Create a new array with all objects copied
    const updatedApprovals = approvals.map((approver) => {
      if (parseInt(approver.id) === parseInt(id)) {
        // Create a new object for the target approver
        const updated = {
          ...approver,
          [name]: value,
        };

        // Handle special cases when status_btn changes
        if (name === "status_btn") {
          const now = new Date().toJSON();

          if (value === "yes") {
            updated.status = true;
            updated.Approved_flg = true;
            updated.time = now;
          } else if (value === "no") {
            updated.status = false;
            updated.Approved_flg = false;
            updated.time = now;
          }
        }

        return updated;
      }

      // Return a copy of other objects (not the original)
      return { ...approver };
    });

    setApprovals(updatedApprovals);
  };

  // overview redirect function
  const handleOpenDocument = () => {
    console.log("documentId0", documentId);
    setOpenViewRequest(true);
    setCloseRequest(false);
  };

  const approvalValidationSchema = yup.object({
    status_btn: yup.string().required("Approval is required"),
    comments: yup.string().required("Description is required"),
  });

  const {
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(approvalValidationSchema),
  });

  const getInitiatorName = () => {
    let firstName = "";
    let lastName = "";
    const isBulkList = WorkflowName === "Attandance Management" || WorkflowName === "payroll management";
    const indexId = parseInt(documentId?.index || 0);

    const data = Array.isArray(requests)
      ? (isBulkList ? requests[indexId - 1] : requests[0])
      : requests;

    // 1. Prioritize Employee_FirstName directly on the data object (confirmed correct for timesheet/leave)
    if (data?.Employee_FirstName || data?.first_name) {
      firstName = data.Employee_FirstName || data.first_name || "";
      lastName =
        data.Employee_LastName ||
        data.Employee_LasttName ||
        data.last_name ||
        "";
    }
    // 2. Try Employee_Id nested object
    else if (data?.Employee_Id && typeof data.Employee_Id === "object") {
      firstName =
        data.Employee_Id.Employee_FirstName ||
        data.Employee_Id.first_name ||
        "";

      lastName =
        data.Employee_Id.Employee_LastName ||
        data.Employee_Id.Employee_LasttName ||
        data.Employee_Id.last_name ||
        "";
    }
    // 3. Fallback to Created_By object
    else if (data?.Created_By && typeof data.Created_By === "object") {
      firstName =
        data.Created_By.Employee_FirstName ||
        data.Created_By.first_name ||
        "";

      lastName =
        data.Created_By.Employee_LastName ||
        data.Created_By.Employee_LasttName ||
        data.Created_By.last_name ||
        "";
    } else if (data?.Created_By?.id || data?.Created_By) {
      const creator = typeof data.Created_By === "object" ? data.Created_By : {};
      firstName =
        creator.Employee_FirstName ||
        creator.first_name ||
        "";

      lastName =
        creator.Employee_LastName ||
        creator.Employee_LasttName ||
        creator.last_name ||
        "";
    }

    let fullName = `${firstName} ${lastName}`.trim();
    if (fullName) return fullName;

    // 4. Fallback to documentId.Initiated_By string
    if (documentId?.Initiated_By) return documentId.Initiated_By;

    if (documentId?.Created_By && typeof documentId.Created_By === "object") {
      const fn = documentId.Created_By.Employee_FirstName || documentId.Created_By.first_name || "";
      const ln = documentId.Created_By.Employee_LastName || documentId.Created_By.Employee_LasttName || documentId.Created_By.last_name || "";
      const name = `${fn} ${ln}`.trim();
      if (name) return name;
    }

    return "Employee";
  };

  const getInitiatorEmail = () => {
    const isBulkList = WorkflowName === "Attandance Management" || WorkflowName === "payroll management";
    const indexId = parseInt(documentId?.index || 0);
    const currentApproverId = indexId;

    const getEmailFromData = (data) => {
      if (!data) return "";
      return (
        data?.Employee_Id?.Email_Id ||
        data?.Employee_Id?.email ||
        data?.Application_Id?.Employee_Id?.Email_Id ||
        data?.Application_Id?.Employee_Id?.email ||
        data?.Created_By?.Email_Id ||
        data?.Created_By?.email ||
        data?.Email_Id ||
        data?.email ||
        ""
      );
    };

    // Handle array of requests
    if (Array.isArray(requests)) {
      const data = isBulkList ? requests[indexId - 1] : requests[0];
      const email = getEmailFromData(data);
      if (email) return email;
    } else {
      const email = getEmailFromData(requests);
      if (email) return email;
    }

    // documentId fallback - prioritize Created_By object fields since documentId?.email / documentId?.Email_Id can refer to the current approver
    const emailFromDoc =
      documentId?.Created_By?.Email_Id ||
      documentId?.Created_By?.email ||
      documentId?.Created_By?.Email ||
      documentId?.Email_Id ||
      documentId?.email;

    if (emailFromDoc) return emailFromDoc;

    // approvals fallback (only as absolute last resort)
    if (
      approvals &&
      Array.isArray(approvals) &&
      currentApproverId &&
      currentApproverId <= approvals.length
    ) {
      const approver = approvals[currentApproverId - 1];
      if (approver?.Email_Id) return approver.Email_Id;
    }

    return "";
  };

  const returnMailToInitiator = async ({ WorkflowName, updatedApprovals, requests }) => {
    try {
      const checkdocument = updatedApprovals?.Approve?.find(
        (opt) => parseInt(opt?.id) === parseInt(employeeId),
      );
      if (!checkdocument) return;
      const mailHTML = generateHRApprovalMail({
        workflowName: FirstLetterCaps(WorkflowName),
        latestApproval: checkdocument,
        requests: requests,
      });
      await axios.post(
        `${BASE_URL}/Felix/Approvalrejectmail/`,
        {
          MailId: getInitiatorEmail(),
          ApproverId: checkdocument?.id,
          mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
          mailhtml: mailHTML,
        },
      );
      console.log("Mail sent to initiator directly from component");
    } catch (err) {
      console.log("Error in sending mail directly from component", err);
    }
  };

  const sendNotification = useCallback((payload) => {
    axios
      .post(`${BASE_URL}/Felix/Notificationscrudwithoutpagination/`, payload)
      .then((res) => {
        console.log("PP", res);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const getMailContent = (findApproverIndex) => {
    const nextApprover = approvals[findApproverIndex + 1];
    const currentApprover = approvals[findApproverIndex];
    const initiatorName = getInitiatorName();

    return `${WorkflowName === "Leave"
      ? `<div style="width: 100%; font-family: Arial, sans-serif;">
                Dear ${nextApprover?.Approvername || "Approver"},<br><br>
                  ${initiatorName} has submitted a <b>Leave request</b> for your approval.<br>
                  To review and respond, <a href='{{url}}'>click here</a>.<br><br>
                  Thanks and Regards,<br>${currentApprover?.Approvername || ""}<br>${currentApprover?.ApproverRole || ""}<br>
            </div>`
      : WorkflowName === "Leave Cancellation"
        ? `<div style="width: 100%; font-family: Arial, sans-serif;">
                Dear ${nextApprover?.Approvername || "Approver"},<br><br>
                  ${initiatorName} has requested to <b>cancel leave</b>.<br>
                  Kindly <a href='{{url}}'>click here</a> to approve or reject the cancellation.<br><br>
                  Thanks and Regards,<br>${currentApprover?.Approvername || ""}<br>${currentApprover?.ApproverRole || ""}<br>
            </div>`
        : WorkflowName === "timesheet" || WorkflowName === "Timesheet"
          ? `<div style="width: 100%; font-family: Arial, sans-serif;">
                Dear ${nextApprover?.Approvername || "Approver"},<br><br>
                  ${initiatorName} has submitted a <b>Timesheet</b> for your approval.<br>
                  Please <a href='{{url}}'>click here</a> to review and take action.<br><br>
                  Thanks and Regards,<br>${currentApprover?.Approvername || ""}<br>${currentApprover?.ApproverRole || ""}<br>
            </div>`
          : WorkflowName === "Reimbursement"
            ? `<div style="width: 100%; font-family: Arial, sans-serif;">
                  Dear ${nextApprover?.Approvername || "Approver"},<br><br>
                    ${initiatorName} has submitted a <b>Reimbursement</b> for your approval.<br>
                    Please <a href='{{url}}'>click here</a> to review and take action.<br><br>
                    Thanks and Regards,<br>${currentApprover?.Approvername || ""}<br>${currentApprover?.ApproverRole || ""}<br>
              </div>`
            : WorkflowName === "Full and Final Settlement"
              ? `<div style="width: 100%; font-family: Arial, sans-serif; min-height: 400px;">
                                      <h4 className="mb-2 text-muted">Dear Approver,</h4>
                                      <div>Please review the below document before approving.</div>
                                      <br/>
                                      <div style="margin-top: 16px; margin-bottom: 8px;">
                                          <div style="display: flex; flex-wrap: wrap; gap: 5px;">
                                              <div style="flex: 1 1 50%; max-width: 80%;">
                                                  <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                                      <div style="width: 40%;"><p style="font-weight: bold;">Name of Employee</p></div>
                                                      <div style="width: 60%;"><p>: ${requests?.Employee_Name || "N/A"}</p></div>
                                                  </div>
                                                  <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                                      <div style="width: 40%;"><p style="font-weight: bold;">Department</p></div>
                                                      <div style="width: 60%;"><p>: ${requests?.Department || "N/A"}</p></div>
                                                  </div>
                                                  <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                                      <div style="width: 40%;"><p style="font-weight: bold;">Resignation Date</p></div>
                                                      <div style="width: 60%;"><p>: ${requests?.Date_Of_Resignation || "N/A"}</p></div>
                                                  </div>
                                                  <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                                      <div style="width: 40%;"><p style="font-weight: bold;">Relieving Date</p></div>
                                                      <div style="width: 60%;"><p>: ${requests?.Releiving_Date || "N/A"}</p></div>
                                                  </div>
                             
                                                  <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                                      <div style="width: 40%;"><p style="font-weight: bold;">Employee Code</p></div>
                                                      <div style="width: 60%;"><p>: ${requests?.Employee_Id || "N/A"}</p></div>
                                                  </div>
                                                  <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                                      <div style="width: 40%;"><p style="font-weight: bold;">Reporting To</p></div>
                                                      <div style="width: 60%;"><p>: ${requests?.Reporting_To || "N/A"}</p></div>
                                                  </div>
                                                  <div style="display: flex; align-items: center; margin-bottom: 5px;">
                                                      <div style="width: 40%;"><p style="font-weight: bold;">Acceptance Date</p></div>
                                                      <div style="width: 60%;"><p>: ${requests?.Acceptance_Date || "N/A"}</p></div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
          
                                      <table border="1" cellpadding="5" cellspacing="0" style="width: 100%; border-collapse: collapse;">
                                          <thead style="background-color: #f5f7fa; color: #017890;">
                                              <tr>
                                                  <th style="text-align: left;">&nbsp;</th>
                                                  <th style="text-align: left;">Month</th>
                                                  <th style="text-align: left;">Days</th>
                                                  <th style="text-align: right;">Amount</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              ${requests?.Salary_Details?.salaryDetails &&
                requests?.Salary_Details?.salaryDetails?.length
                ? requests?.Salary_Details?.salaryDetails
                  ?.map(
                    (detail) => `
                                                  <tr>
                                                      <td>Salary</td>
                                                      <td>${detail?.month || "N/A"}</td>
                                                      <td>${detail?.days || "N/A"}</td>
                                                      <td style="text-align: right;">${formatIndianNumber(detail?.amount) || 0}</td>
                                                  </tr>
                                              `,
                  )
                  .join("")
                : `
                                                  <tr>
                                                      <td colspan="4">No Records</td>
                                                  </tr>
                                              `
              }
                                              <tr>
                                                  <td>Gratuity</td>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style="text-align: right;">${formatIndianNumber(requests?.Salary_Details?.gratuity) || 0}</td>
                                              </tr>
                                              <tr>
                                                  <td>Leave Encashment</td>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style="text-align: right;">${formatIndianNumber(requests?.Salary_Details?.leaveEncashment) || 0}</td>
                                              </tr>
                                              ${requests?.Salary_Details?.reimbursement &&
                Object.keys(requests?.Salary_Details?.reimbursement).length
                ? `
                                                  <tr>
                                                      <td style="font-weight: bold;">Reimbursement</td>
                                                      <td>&nbsp;</td>
                                                      <td>&nbsp;</td>
                                                      <td>&nbsp;</td>
                                                  </tr>
                                                  ${Object.entries(requests?.Salary_Details?.reimbursement)
                  .map(
                    ([key, value]) => `
                                                      <tr>
                                                          <td>${key}</td>
                                                          <td>&nbsp;</td>
                                                          <td>&nbsp;</td>
                                                          <td style="text-align: right;">${formatIndianNumber(value)}</td>
                                                      </tr>
                                                  `,
                  )
                  .join("")}
                                              `
                : ""
              }
                                              <tr>
                                                  <td style="font-weight: bold;">Total Earnings (A)</td>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style="text-align: right;">${formatIndianNumber(requests?.Salary_Details?.totalEarnings) || 0}</td>
                                              </tr>
                                              <tr>
                                                  <td style="font-weight: bold;">Provident Fund</td>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style="text-align: right;">${formatIndianNumber(requests?.Salary_Details?.providentFund) || 0}</td>
                                              </tr>
                                              <tr>
                                                  <td style="font-weight: bold;">Professional Tax</td>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style="text-align: right;">${formatIndianNumber(requests?.Salary_Details?.professionalTax) || 0}</td>
                                              </tr>
                                              <tr>
                                                  <td style="font-weight: bold;">ESI</td>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style="text-align: right;">${formatIndianNumber(requests?.Salary_Details?.esi) || 0}</td>
                                              </tr>
                                              <tr>
                                                  <td>Income Tax (TDS)</td>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style="text-align: right;">${formatIndianNumber(requests?.Salary_Details?.incomeTax) || 0}</td>
                                              </tr>
                                              <tr>
                                                  <td style="font-weight: bold;">Total Deductions (B)</td>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style="text-align: right;">${formatIndianNumber(requests?.Salary_Details?.totalDeductions) || 0}</td>
                                              </tr>
                                              <tr>
                                                  <td style="font-weight: bold;">Net Settlement Dues</td>
                                                  <td>&nbsp;</td>
                                                  <td>&nbsp;</td>
                                                  <td style="text-align: right;">${formatIndianNumber(requests?.Salary_Details?.netSettlement) || 0}</td>
                                              </tr>
                                          </tbody>
                                      </table>
          
                                      <br/>
                                      <p>
                                          Click the link to go to the approval page. <a href="{{url}}">Click Here</a>.
                                      </p>
                                      <br />
                                      <p>
                                          If you have any issues during the request approval or require
                                          any assistance, please do not hesitate to contact us at
                                          'it-support@foyer.com'.
                                      </p>
                                      <br />
                                      <p>
                                          <span><h5>Best Regards,</h5></span>
                                          ${requests?.Created_By?.Employee_FirstName || "N/A"} ${requests?.Created_By?.Employee_LasttName || ""},<br/>
                                          ${requests?.Created_By?.Designation || "N/A"},<br/>
                                          ${requests?.Company_Id?.Company_Name || "N/A"}
                                      </p>
                                  </div>`
              : WorkflowName === "Attandance Management"
                ? `<div style="width: 100%; font-family: Arial, sans-serif;">
                      <div className="card-body"> 
                                    <h4 className="card-subtitle mb-2 text-muted">Dear Approver,</h4>
                      
                                    <div className="card-text">
                                    <div>
                                    Attached is the [${requests[0]?.Month}] employee attendance report for your review and approval.
                                    </div>
                                    <br/>
                                    <div>
                                      <p>Total Employees : ${employeeLists?.count}</p>
                                      <p>Total Attendance : ${requests?.length}</p>
                                    </div>
                                    <br/>
                                    <p>
                                    Click the link to go to the approval page. <a href="{{url}}">Click Here</a>.
                                    </p>
                                    <br/>
                                    <div>
                                    Your approval is required to proceed with payroll.
                                    </div>
                        <br />
                        <p>Best Regards,</p>
                        <p>${requests[0]?.EmployeeName || ""},</p>
                        <p>${requests[0]?.Designation || ""}</p>
                    </div>
                  </div>`
                : `<div style="width: 100%; font-family: Arial, sans-serif;">
                      <h4 className="mb-2 text-muted">Dear Approver,</h4>
                     
                      <div className="card-text">
                  <div>
                    Please find attached the [${requests[0]?.Month}] payroll report for your review and approval. 
                  </div>
                  <br/>
                  <div>
                    <p>Total Employees : ${employeeLists?.count}</p>
                    <p>Processed Payrolls : ${requests?.length}</p>
                  </div> 
                  <br/>
                  <p>
                    Click the link to go to the approval page. <a href="{{url}}"> Click Here</a>.
                  </p>
                  <br/>
                  <p>
                    Your prompt approval is essential to proceed with salary disbursal.
                  </p>
                    
                          <br />
                          <p>Best Regards,</p>
                          <p>${requests[0]?.Employee_Name || ""},</p>
                  <p>${requests[0]?.Designation || ""}</p>
                      </div>
                    </div>`
      }`;
  };

  console.log("moduleName", moduleName, requests);
  const handleUpdateRequest = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const checkdocument = approvals?.find(
      (opt) => parseInt(opt?.id) === parseInt(employeeId),
    );
    if (checkdocument != undefined) {
      if (!documentId?.Approve?.length) return;

      let listsdata = approvals?.map((approval, index) => {
        // Update the flag only for the last approval
        if (parseInt(approval?.id) === parseInt(employeeId)) {
          return { ...approval, OneTimeApproved_flg: true };
        }
        return approval;
      });
      console.log("listsdata", listsdata);

      setApprovals(listsdata);

      var payload = {
        Documentapproval_Id: documentId?.Documentapproval_Id,
        Request_Id: documentId?.Request_Id,
        Created_By: documentId?.Created_By?.id,
        Updated_By: documentId?.Updated_By?.id,
        Approval_Id: listsdata,
        Approve: listsdata,
        Request_Key: documentId?.Request_Key,
        Request_Name: documentId?.Request_Name,
      };
      await axios
        .put(`${BASE_URL}/Felix/DocumentapprovalCRUD/ `, payload)
        .then(async (res) => {
          const updatedApprovals = res?.data;
          const findApproverIndex = listsdata?.findIndex((opt) => parseInt(opt?.id) === parseInt(employeeId));
          const isApproved = checkdocument?.status_btn === "yes";
          const isFinal = findApproverIndex === listsdata.length - 1;

          if (res?.data?.id && isApproved) {
            console.log("moduleNamemoduleName", moduleName);
            if (isFinal) {
              if (moduleName === "Erpapp.leave" || WorkflowName === "Leave") {
                await axios
                  .put(
                    `${BASE_URL}/Felix/updateleave/ `,
                    {
                      ...requests,
                      Approved_Flag: true,
                      Status: true,
                      Leave_flg: "Approved",
                      Sanctioned_Date: new Date().toISOString().substring(0, 10),
                      Sancleavefrom_Date: new Date().toISOString().substring(0, 10),
                      Sancleaveto_Date: new Date().toISOString().substring(0, 10),
                      Leavetype_Id: parseInt(requests?.Leavetype_Id?.id || requests?.Leavetype_Id),
                      Employee_Id: parseInt(requests?.Employee_Id?.id || requests?.Employee_Id),
                      Approved_By: employeeId,
                      Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                      Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                      Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                      Updated_By: employeeId,
                    },
                    header,
                  )
                  .then((updateRes) => {
                    toast.success("Approved Successfully");
                    setMainPage(true);
                    setOpen(false);
                    fetchData();
                    returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                    const notifPayload = {
                      Notification_Msg: `Leave No ${requests?.Application_Id || requests?.id} is approved by ${checkdocument?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(checkdocument?.id),
                      Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                      Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                      Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                    };
                    sendNotification(notifPayload);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else if (
                moduleName === "Erpapp.leavecancellation" ||
                moduleName === "Erpapp.cancelleave" ||
                WorkflowName === "Leave Cancellation"
              ) {
                await axios
                  .post(
                    `${BASE_URL}/Felix/ApproveLeaveCancellation/`,
                    {
                      Leave_Id: parseInt(requests?.Application_Id?.id || requests?.Application_Id),
                      LeaveCancel_Id: parseInt(requests?.id),
                    },
                    header,
                  )
                  .then(async (updateRes) => {
                    if (updateRes?.status === 200 && updateRes?.data?.id) {
                      toast.success("Leave Cancellation has been Approved");
                      
                      // send approval mail to initiator
                      try {
                        const mailHTML = generateHRApprovalMail({
                          workflowName: FirstLetterCaps(WorkflowName),
                          latestApproval: checkdocument,
                          requests: requests,
                        });
                        await axios.post(
                          `${BASE_URL}/Felix/Approvalrejectmail/`,
                          {
                            MailId: getInitiatorEmail(),
                            ApproverId: checkdocument?.id,
                            mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                            mailhtml: mailHTML,
                          },
                        );
                      } catch (err) {
                        console.log("Error in sending mail", err);
                      }

                      setMainPage(true);
                      setOpen(false);
                      fetchData();

                      const notifPayload = {
                        Notification_Msg: `Leave Cancellation No ${requests?.Cancellation_Id || requests?.id} is approved by ${checkdocument?.Approvername}`,
                        Open_flg: false,
                        User_Id: parseInt(checkdocument?.id),
                        Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                        Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                        Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                      };
                      sendNotification(notifPayload);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else if (
                moduleName === "Erpapp.timesheet" ||
                WorkflowName === "timesheet" ||
                WorkflowName === "Timesheet"
              ) {
                await axios
                  .put(
                    `${BASE_URL}/Felix/TimeSheetwithoutCRUD/ `,
                    {
                      ...requests,
                      Approved_Flag: true,
                      Status: true,
                      Filter_status: "Approved",
                      Timesheet_flg: "Approved",
                      Employee_Id: parseInt(requests?.Employee_Id?.id || requests?.Employee_Id),
                      Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                      Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                      Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                      Updated_By: employeeId,
                    },
                    header,
                  )
                  .then((updateRes) => {
                    toast.success("Approved Successfully");
                    setMainPage(true);
                    setOpen(false);
                    fetchData();
                    returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                    const notifPayload = {
                      Notification_Msg: `Timesheet No ${requests?.TimeSheet_Id || requests?.id} is approved by ${checkdocument?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(checkdocument?.id),
                      Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                      Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                      Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                    };
                    sendNotification(notifPayload);
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else if (
                moduleName === "Erpapp.reimbursement" ||
                WorkflowName === "Reimbursement"
              ) {
                await axios
                  .put(
                    `${BASE_URL}/Felix/EmployeeclaimsCRUD/ `,
                    {
                      ...requests,
                      Approved_Flag: true,
                      Status: true,
                      Claim_Status: "Approved",
                      Updated_By: employeeId,
                    },
                    header,
                  )
                  .then((updateRes) => {
                    toast.success("Approved Successfully");
                    setMainPage(true);
                    setOpen(false);
                    fetchData();
                    returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else if (moduleName === "Erpapp.fullandfinal") {
                await axios
                  .put(
                    `${BASE_URL}/Felix/FullandFinalCRUD/ `,
                    {
                      ...requests,
                      Approved_Flg: true,
                      Status: true,
                      Filter_status: "Approved",
                      Updated_By: userId,
                    },
                    header,
                  )
                  .then((updateRes) => {
                    toast.success("Approved Successfully");
                    setMainPage(true);
                    setOpen(false);
                    fetchData();
                    returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else if (
                moduleName === "Erpapp.attandancemaster" ||
                documentId?.Request_Name === "Attandance Management"
              ) {
                try {
                  const response = await axios.get(
                    `${BASE_URL}/Felix/AttendanceList/`,
                    {
                      params: {
                        Partner_Id: requests?.Partner_Id,
                        Year: requests?.Year,
                        Month: requests?.Month,
                      },
                    },
                  );

                  if (response?.data) {
                    await axios
                      .put(
                        `${BASE_URL}/Felix/Attandancemasterflagchange/ `,
                        {
                          Attandancemasterid: response?.data?.map((opt) => opt?.id),
                          Approved_Flag: true,
                          Status: true,
                          Filter_status: "Approved",
                          Updated_By: userId,
                          tenant: Tenantname,
                        },
                        header,
                      )
                      .then((updateRes) => {
                        toast.success("Approved Successfully");
                        setMainPage(true);
                        setOpen(false);
                        fetchData();
                        returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }
                } catch (error) {
                  console.error("Error fetching payslip data:", error);
                }
              } else if (moduleName === "Erpapp.payslipheader") {
                try {
                  const response = await axios.get(
                    `${BASE_URL}/Felix/PayslipHeaderList/`,
                    {
                      params: {
                        Partner_Id: requests?.Partner_Id,
                        Year: requests?.Year,
                        Month: requests?.Month,
                      },
                    },
                  );

                  if (response?.data) {
                    await axios
                      .put(
                        `${BASE_URL}/Felix/Payslipheaderflagchange/ `,
                        {
                          Payslipheaderid: response?.data?.map((opt) => opt?.id),
                          Updated_By: userId,
                          Approved_Flag: true,
                          Status: true,
                          Filter_status: "Approved",
                        },
                        header,
                      )
                      .then((updateRes) => {
                        toast.success("Approved Successfully");
                        setMainPage(true);
                        setOpen(false);
                        fetchData();
                        returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }
                } catch (error) {
                  console.error("Error fetching payslip data:", error);
                }
              } else if (moduleName === "Erpapp.employeeresignation") {
                await axios
                  .put(
                    `${BASE_URL}/Felix/EmployeeResignationCRUD/ `,
                    {
                      ...requests,
                      Releiving_Date: releivingDate,
                      Updated_By: userId,
                      Approved_Flg: true,
                      Filter_status: "Approved",
                    },
                    header,
                  )
                  .then((updateRes) => {
                    toast.success("Approved Successfully");
                    setMainPage(true);
                    setOpen(false);
                    fetchData();
                    returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              } else {
                toast.error("Not Approved.");
                setMainPage(true);
                setOpen(false);
                fetchData();
              }
            } else {
              // Approved, but NOT final: forward to next approver
              RequestSendForNextApprover(updatedApprovals);
              returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
              setMainPage(true);
              setOpen(false);
              fetchData();
            }
          } else if (res?.data?.id && !isApproved) {
            // Rejected
            if (moduleName === "Erpapp.leave" || WorkflowName === "Leave") {
              await axios
                .put(
                  `${BASE_URL}/Felix/updateleave/ `,
                  {
                    ...requests,
                    Approved_Flag: false,
                    Status: true,
                    Leave_flg: "Rejected",
                    Leavetype_Id: parseInt(requests?.Leavetype_Id?.id || requests?.Leavetype_Id),
                    Employee_Id: parseInt(requests?.Employee_Id?.id || requests?.Employee_Id),
                    Approved_By: employeeId,
                    Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                    Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                    Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                    Updated_By: employeeId,
                  },
                  header,
                )
                .then((updateRes) => {
                  toast.success("Rejected Successfully");
                  setMainPage(true);
                  setOpen(false);
                  fetchData();
                  returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                  const notifPayload = {
                    Notification_Msg: `Leave No ${requests?.Application_Id || requests?.id} is rejected by ${checkdocument?.Approvername}`,
                    Open_flg: false,
                    User_Id: parseInt(checkdocument?.id),
                    Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                    Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                    Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                  };
                  sendNotification(notifPayload);
                })
                .catch((error) => {
                  console.log(error);
                });
            } else if (
              moduleName === "Erpapp.leavecancellation" ||
              WorkflowName === "Leave Cancellation"
            ) {
              await axios
                .put(
                  `${BASE_URL}/Felix/LeavecancellationwithouttokenCRUD/ `,
                  {
                    ...requests,
                    Leavecancel_flg: false,
                    Status: true,
                    Leave_flg: "Rejected",
                    Application_Id: parseInt(requests?.Application_Id?.id || requests?.Application_Id),
                    Leavetype_Id: parseInt(requests?.Leavetype_Id?.id || requests?.Leavetype_Id),
                    Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                    Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                    Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                    Updated_By: employeeId,
                  },
                  header,
                )
                .then(async (updateRes) => {
                  if (updateRes?.data?.id) {
                    toast.success("Leave Cancellation has been Rejected");

                    // send rejection mail to initiator
                    try {
                      const mailHTML = generateHRApprovalMail({
                        workflowName: FirstLetterCaps(WorkflowName),
                        latestApproval: checkdocument,
                        requests: requests,
                      });
                      await axios.post(
                        `${BASE_URL}/Felix/Approvalrejectmail/`,
                        {
                          MailId: getInitiatorEmail(),
                          ApproverId: checkdocument?.id,
                          mailsubject: `${FirstLetterCaps(WorkflowName)} - Approval Status`,
                          mailhtml: mailHTML,
                        },
                      );
                    } catch (err) {
                      console.log("Error in sending mail", err);
                    }

                    setMainPage(true);
                    setOpen(false);
                    fetchData();

                    const notifPayload = {
                      Notification_Msg: `Leave Cancellation No ${requests?.Cancellation_Id || requests?.id} is rejected by ${checkdocument?.Approvername}`,
                      Open_flg: false,
                      User_Id: parseInt(checkdocument?.id),
                      Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                      Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                      Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                    };
                    sendNotification(notifPayload);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else if (
              moduleName === "Erpapp.timesheet" ||
              WorkflowName === "timesheet" ||
              WorkflowName === "Timesheet"
            ) {
              await axios
                .put(
                  `${BASE_URL}/Felix/TimeSheetwithoutCRUD/ `,
                  {
                    ...requests,
                    Approved_Flag: false,
                    Status: true,
                    Filter_status: "Rejected",
                    Timesheet_flg: "Rejected",
                    Employee_Id: parseInt(requests?.Employee_Id?.id || requests?.Employee_Id),
                    Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                    Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                    Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                    Updated_By: employeeId,
                  },
                  header,
                )
                .then((updateRes) => {
                  toast.success("Rejected Successfully");
                  setMainPage(true);
                  setOpen(false);
                  fetchData();
                  returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                  const notifPayload = {
                    Notification_Msg: `Timesheet No ${requests?.TimeSheet_Id || requests?.id} is rejected by ${checkdocument?.Approvername}`,
                    Open_flg: false,
                    User_Id: parseInt(checkdocument?.id),
                    Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By),
                    Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id),
                    Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id),
                  };
                  sendNotification(notifPayload);
                })
                .catch((error) => {
                  console.log(error);
                });
            } else if (
              moduleName === "Erpapp.reimbursement" ||
              WorkflowName === "Reimbursement"
            ) {
              await axios
                .put(
                  `${BASE_URL}/Felix/EmployeeclaimsCRUD/ `,
                  {
                    ...requests,
                    Approved_Flag: false,
                    Status: true,
                    Claim_Status: "Rejected",
                    Updated_By: employeeId,
                  },
                  header,
                )
                .then((updateRes) => {
                  toast.success("Rejected Successfully");
                  setMainPage(true);
                  setOpen(false);
                  fetchData();
                  returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                })
                .catch((error) => {
                  console.log(error);
                });
            } else if (moduleName === "Erpapp.fullandfinal") {
              await axios
                .put(
                  `${BASE_URL}/Felix/FullandFinalCRUD/ `,
                  {
                    ...requests,
                    Approved_Flg: false,
                    Status: true,
                    Filter_status: "Rejected",
                    Updated_By: userId,
                  },
                  header,
                )
                .then((updateRes) => {
                  toast.success("Rejected Successfully");
                  setMainPage(true);
                  setOpen(false);
                  fetchData();
                  returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                })
                .catch((error) => {
                  console.log(error);
                });
            } else if (moduleName === "Erpapp.attandancemaster") {
              try {
                const response = await axios.get(
                  `${BASE_URL}/Felix/AttendanceList/`,
                  {
                    params: {
                      Partner_Id: requests?.Partner_Id,
                      Year: requests?.Year,
                      Month: requests?.Month,
                    },
                  },
                );

                if (response?.data) {
                  await axios
                    .put(
                      `${BASE_URL}/Felix/Attandancemasterflagchange/ `,
                      {
                        Attandancemasterid: response?.data?.map((opt) => opt?.id),
                        Approved_Flag: false,
                        Status: true,
                        Filter_status: "Rejected",
                        Updated_By: userId,
                        tenant: Tenantname,
                      },
                      header,
                    )
                    .then((updateRes) => {
                      toast.success("Rejected Successfully");
                      setMainPage(true);
                      setOpen(false);
                      fetchData();
                      returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }
              } catch (error) {
                console.error("Error fetching payslip data:", error);
              }
            } else if (moduleName === "Erpapp.payslipheader") {
              try {
                const response = await axios.get(
                  `${BASE_URL}/Felix/PayslipHeaderList/`,
                  {
                    params: {
                      Partner_Id: requests?.Partner_Id,
                      Year: requests?.Year,
                      Month: requests?.Month,
                    },
                  },
                );

                if (response?.data) {
                  await axios
                    .put(
                      `${BASE_URL}/Felix/Payslipheaderflagchange/ `,
                      {
                        Payslipheaderid: response?.data?.map((opt) => opt?.id),
                        Updated_By: userId,
                        Approved_Flag: false,
                        Status: true,
                        Filter_status: "Rejected",
                      },
                      header,
                    )
                    .then((updateRes) => {
                      toast.success("Rejected Successfully");
                      setMainPage(true);
                      setOpen(false);
                      fetchData();
                      returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                    })
                    .catch((error) => {
                      console.log(error);
                    });
                }
              } catch (error) {
                console.error("Error fetching payslip data:", error);
              }
            } else if (moduleName === "Erpapp.employeeresignation") {
              await axios
                .put(
                  `${BASE_URL}/Felix/EmployeeResignationCRUD/ `,
                  {
                    ...requests,
                    Updated_By: userId,
                    Approved_Flg: false,
                    Filter_status: "Rejected",
                  },
                  header,
                )
                .then((updateRes) => {
                  toast.success("Rejected Successfully");
                  setMainPage(true);
                  setOpen(false);
                  fetchData();
                  returnMailToInitiator({ WorkflowName, updatedApprovals, requests });
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const RequestSendForNextApprover = (updatedApprovals) => {
    const findApproverIndex =
      updatedApprovals?.Approve?.findIndex((opt) => parseInt(opt?.id) === parseInt(employeeId)) ??
      -1;
    const nextApprover = approvals[findApproverIndex + 1];
    const currentApprover = approvals[findApproverIndex];
    try {
      var payload = {
        mailhtml: getMailContent(findApproverIndex),
        Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By || documentId?.Created_By?.id || documentId?.Created_By || userId),
        mailsubject:
          WorkflowName === "Leave"
            ? "Leave Approval Request"
            : WorkflowName === "Leave Cancellation"
              ? "Leave Cancellation Approval Request"
              : WorkflowName === "timesheet" || WorkflowName === "Timesheet"
                ? "Timesheet Approval Request"
                : "Mail for Approval",
        approver_name: nextApprover?.Approvername,
        Approverid: nextApprover?.id,
        PreviousApproverid: currentApprover?.id,
        Document_Type: WorkflowName,
        id: parseInt(requests?.id),
        Comments: String(findApproverIndex + 1),
        documentapprovalid: documentId?.Documentapproval_Id || "",
        index: parseInt(findApproverIndex + 2),
        Initiated_By: getInitiatorName(),
        Employee_Id: "",
        Designation: HeadApproverRole || "",
        first_name: HeadApproverName || "",
        Headname: HeadApproverName || "",
        Url: ` `,
        tenant: Tenantname,
        total_employees: employeeLists?.count,
        processed_payroll: requests?.length,
        process_month: requests[0]?.Month || "",
      };
      axios
        .post(`${BASE_URL}/Felix/HRApprovalsystem/ `, payload)
        .then(async (res) => {
          console.log("Send");

          // SEND PUSH NOTIFICATION FOR NEXT APPROVER (LEAVE, TIMESHEET, & LEAVE CANCELLATION)
          if (
            WorkflowName === "Leave" ||
            WorkflowName === "Leave Cancellation" ||
            WorkflowName === "timesheet" ||
            WorkflowName === "Timesheet"
          ) {
            try {
              await axios.post(`${BASE_URL}/SendPushNotificationView/`, {
                User_Id: payload.Approverid,
                Title: payload.mailsubject,
                Body: `You have a new approval request from ${payload.Initiated_By}`,
              });
              console.log("Push notification sent for next approver in DocumentUserApproval");
            } catch (err) {
              console.log("Push notification error in DocumentUserApproval", err);
            }
          }

          // Send notification to the initiator
          const notifPayload = {
            Notification_Msg: `${WorkflowName} No ${payload.id} is approved by ${currentApprover?.Approvername}`,
            Open_flg: false,
            User_Id: parseInt(currentApprover?.id),
            Created_By: parseInt(requests?.Created_By?.id || requests?.Created_By || documentId?.Created_By?.id || documentId?.Created_By),
            Partner_Id: parseInt(requests?.Partner_Id?.id || requests?.Partner_Id || documentId?.Partner_Id || 1),
            Company_Id: parseInt(requests?.Company_Id?.id || requests?.Company_Id || documentId?.Company_Id || 1),
          };
          sendNotification(notifPayload);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <Div>
      {closeRequest === true && (
        <form onSubmit={handleUpdateRequest}>
          <Div>
            <Typography variant="h2">Document Approvals</Typography>
            <Typography variant="h4">
              Approvers shall use this form to approve or Reject documents
              received from users.
            </Typography>

            <Div className="row" sx={{ mt: 1 }}>
              <Div className="col col-8">
                <Grid container columns={12} sx={{ mt: 1 }}>
                  <Grid item xs={3}>
                    <Div>
                      <Typography variant="h5" fontWeight={500}>
                        Request No #
                      </Typography>
                      <Typography variant="h5" fontWeight={500}>
                        Initiated by user
                      </Typography>
                    </Div>
                  </Grid>
                  <Grid item xs={1}>
                    <Div>
                      <Typography variant="h5"> : </Typography>
                      <Typography variant="h5"> : </Typography>
                    </Div>
                  </Grid>
                  <Grid item xs={8}>
                    <Div>
                      <Typography variant="h5">{reqId}</Typography>
                      <Typography variant="h5">
                        {documentId?.Initiated_By
                          ? documentId?.Initiated_By
                          : initiated?.Employee_FirstName
                            ? `${initiated?.Employee_FirstName || ""} ${initiated?.Employee_LasttName || ""
                            }`
                            : `${initiated?.first_name || ""} ${initiated?.last_name || ""
                            }`}
                      </Typography>
                    </Div>
                  </Grid>
                </Grid>
              </Div>
              <Div className="col col-4">
                <Div sx={{ textAlign: "end", mt: 2, mr: 4 }}>
                  {requests?.id !== undefined && (
                    <CustomButton
                      label="View Document"
                      Icon="viewIcon"
                      onClick={handleOpenDocument}
                      sx={{ minWidth: "200px !important" }}
                    />
                  )}
                </Div>
              </Div>
            </Div>

            <Div className="row" sx={{ mt: 3, minWidth: "400px" }}>
              <Div className="col-12 d-flex ps-1">
                {approvals &&
                  approvals?.map((data, inx) => {
                    return (
                      <>
                        <Grid container xs={3} key={inx}>
                          <Grid item xs={12} md={9}>
                            <Card
                              className="card"
                              sx={{ p: 1.5, boxShadow: "none" }}
                              style={{ padding: "15px", height: "130px" }}
                            >
                              <Typography
                                variant="h5"
                                textAlign={"center"}
                                sx={{ height: "40px" }}
                              >
                                {data?.Approvername}
                              </Typography>
                              <Typography
                                variant="h5"
                                textAlign={"center"}
                                color={"#000000"}
                                fontWeight={500}
                                sx={{ height: "40px" }}
                              >
                                {data?.ApproverRole}
                              </Typography>
                              {data?.Approved_flg === true ? (
                                <Typography
                                  variant="text"
                                  color="success"
                                  sx={{
                                    cursor: "default",
                                    color: "#3BD2A2",
                                    textAlign: "center",
                                    fontSize: "15px",
                                  }}
                                >
                                  Approved
                                </Typography>
                              ) : (
                                <Typography
                                  variant="text"
                                  color="warning"
                                  textAlign={"center"}
                                  sx={{
                                    cursor: "default",
                                    color: "#F39711",
                                    textAlign: "center",
                                    fontSize: "15px",
                                  }}
                                >
                                  Pending
                                </Typography>
                              )}
                            </Card>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={3}
                            sx={{
                              display:
                                approvals?.length === inx + 1 ? "none" : "flex",
                              alignItems: "center",
                            }}
                          >
                            <Div
                              sx={{
                                width: "90px",
                                height: "1px",
                                borderBottom: "1px solid #8F8F8F",
                              }}
                            ></Div>
                            <span>{`> `}</span>
                          </Grid>
                        </Grid>
                      </>
                    );
                  })}
              </Div>
            </Div>

            <Div className="row mt-3">
              <Div className="col-6">
                {approvals
                  // ?.filter((opt) => opt?.Approved_flg === false && opt?.id === employeeId && !opt?.status_btn) // Filter approvals for the employee that are pending and have no status set
                  ?.map((option, index) => {
                    const { comments, status_btn, id } = option;
                    console.log("optionoption", option);
                    return (
                      <Div
                        key={index}
                        sx={{
                          mt: 1.5,
                          display: parseInt(id) === parseInt(employeeId) ? "block" : "none",
                        }}
                      >
                        <Div className="row">
                          <Div className="col-8">
                            <Typography variant="h5">
                              Approve <span style={{ color: "red" }}>*</span>
                            </Typography>
                            <FormControlLabel
                              control={
                                <Radio
                                  color="primary"
                                  size="small"
                                  name="status_btn"
                                  value="yes"
                                  checked={status_btn === "yes"}
                                  onChange={(e) =>
                                    handleChangeApproverRequest(e, index, id)
                                  }
                                />
                              }
                              label="Yes"
                            />

                            <FormControlLabel
                              control={
                                <Radio
                                  color="primary"
                                  size="small"
                                  name="status_btn"
                                  value="no"
                                  checked={status_btn === "no"}
                                  onChange={(e) =>
                                    handleChangeApproverRequest(e, index, id)
                                  }
                                />
                              }
                              label="No"
                            />
                            <Div style={{ color: "red" }}>
                              {errors.status_btn?.message}
                            </Div>
                          </Div>
                          {moduleName === "Erpapp.employeeresignation" && (
                            <Div className="col-4">
                              <Typography variant="h5">
                                Date of Resignation{" "}
                                <span style={{ color: "red" }}>*</span>
                              </Typography>
                              <ErpDateField
                                id="releivingDate"
                                name="releivingDate"
                                value={releivingDate}
                                onChange={(e) => {
                                  setReleivingDate(e.target.value);
                                }}
                                variant="outlined"
                                InputProps={{
                                  inputProps: {
                                    min: requests?.Request_To_Releive_Date,
                                  },
                                }}
                              />
                            </Div>
                          )}
                        </Div>

                        <Div className="row" sx={{ mt: 1 }}>
                          <Typography
                            variant="h5"
                            className="col-8 input-label"
                          >
                            Enter your Comments{" "}
                            <span style={{ color: "red" }}>*</span>
                          </Typography>

                          <Div className="col-12">
                            <TextField
                              className={`col-12 multiline-box ${errors.comments ? "is-invalid" : ""
                                } `}
                              rows={4}
                              multiline
                              name="comments"
                              value={comments}
                              onChange={(e) =>
                                handleChangeApproverRequest(e, index, id)
                              }
                              placeholder="Enter your Comments here..."
                            />
                          </Div>
                        </Div>
                      </Div>
                    );
                  })}
              </Div>
            </Div>

            <Div
              className="row"
              sx={{
                width: "100%",
                display: "flex",
                alignItems: "end",
                justifyContent: "space-between",
              }}
            >
              <Div sx={{ mt: 3 }}>
                <Div
                  sx={{
                    display: "flex",
                    gap: "210px",
                    justifyContent: "space-between",
                  }}
                >
                  <CustomButton
                    label="Close"
                    Icon="closeIcon"
                    onClick={handleBack}
                  />
                  <ErpSaveUpdateButton
                    type="submit"
                    name={"Submit"}
                    loading={isLoading}
                  />
                </Div>
              </Div>
            </Div>
          </Div>
          <br />
        </form>
      )}

      <Div>
        {/* ht */}
        {openViewRequest === true && WorkflowName === "Leave" && (
          <ViewApprovalLeaves
            overviewItems={requests}
            setApprovalMaterial={setOpenViewRequest}
            setListLeaves={setCloseRequest}
            dateFormat={dateFormat}
          />
        )}
        {openViewRequest === true && WorkflowName === "Leave Cancellation" && (
          <LeaveCancellationDocumentApproval
            openViewRequest={openViewRequest}
            setOpenViewRequest={(val) => {
              setOpenViewRequest(val);
              if (!val) {
                setCloseRequest(true);
              }
            }}
            value={value}
            handleChange={handleChange}
            requests={requests}
            approvalStatus={documentId}
            workflows={[]}
            updateHistory={[]}
          />
        )}
        {openViewRequest === true &&
          (WorkflowName === "timesheet" || WorkflowName === "Timesheet") && (
            <ViewTimesheets
              currentApprovalTimesheets={requests}
              setApprovalMaterial={setOpenViewRequest}
              setListService={setCloseRequest}
              dateFormat={dateFormat}
            />
          )}
        {openViewRequest === true &&
          (WorkflowName === "reimbursement" ||
            WorkflowName === "Reimbursement" ||
            moduleName === "Erpapp.employeeclaims") && (
            <ViewEmployeeClaims
              currentData={requests}
              setListOverview={setOpenViewRequest}
              setlistreimbursement={setCloseRequest}
              dateFormat={dateFormat}
            />
          )}
        {openViewRequest === true &&
          (WorkflowName === "Attandance Management" ||
            moduleName === "Erpapp.attandancemaster") && (
            <AttendanceDocumentApproval
              requests={requests}
              setRequests={setRequests}
              openViewRequest={openViewRequest}
              setOpenViewRequest={setOpenViewRequest}
              setCloseRequest={setCloseRequest}
              dateFormat={dateFormat}
            />
          )}
        {openViewRequest === true &&
          (WorkflowName === "payroll management" ||
            moduleName === "Erpapp.payslipheader") && (
            <PayslipDocumentApproval
              requests={requests}
              setRequests={setRequests}
              openViewRequest={openViewRequest}
              setOpenViewRequest={setOpenViewRequest}
              setCloseRequest={setCloseRequest}
              dateFormat={dateFormat}
            />
          )}
        {openViewRequest === true && moduleName === "Erpapp.fullandfinal" && (
          <OverviewFullandFinalSettlement
            currentSettlement={requests}
            setOverviewSettlement={setOpenViewRequest}
            setCurrent={setCloseRequest}
            dateFormat={dateFormat}
          />
        )}
        {openViewRequest === true &&
          moduleName === "Erpapp.employeeresignation" && (
            <ViewResignation
              currentResignations={requests}
              setViewResignation={setOpenViewRequest}
              setListResignation={setCloseRequest}
              dateFormat={dateFormat}
            />
          )}
      </Div>
    </Div>
  );
}

export default DocumentUserApproval;